import React, { Component } from 'react';
import StatusService from "../Services/ClousStatusService";

class OTCloudStatusPreview extends Component {

    constructor(props) {
        super(props);

        this.data = props.data;
    }

    getRenderData() {
        let service = new StatusService( this.data);
        return service.getCloudStatusObjectOT(this.props.previewValue);
    }

    render() {
        var renderObject = this.getRenderData();
        if (renderObject !== null) {

            return (
                <div>
                    <div style={{ height: "50px" }}></div>
                    <table style={{ width: "99%" }}>
                        <tbody><tr>
                            <td rowSpan="2" className="status-image">
                                {renderObject.image}
                            </td>
                            <td className="status-header-text">
                                <div id="acsd_status-header">{renderObject.header}
                                    <br /> </div>
                            </td>
                        </tr>
                            <tr>
                                <td className="status-description-text">
                                    <div id="acsd_status-description"><br /><br />{renderObject.description}
                                    </div>
                                </td>
                            </tr>
                        </tbody></table>
                </div>
            );
        }
        else

            return (
                <div>
                    Error!
           </div>
            )
    }
}



export default OTCloudStatusPreview;

